import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { parse, format, AsYouType } from 'libphonenumber-js';
import {Router} from '@angular/router';
declare var $: any;
declare var body: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: 'app-business-roles',
  templateUrl: './business-roles.component.html',
  styleUrls: ['./business-roles.component.css']
})
export class BusinessRolesComponent implements OnInit {
  nao = new Nanobar();
  rolesData: any;
  personName = '';
  personEmail = '';
  personEmailError = '';
  personRole = new Array;
  addRoleBtn = true;
  updateRoleBtn = true;
  roleSucessData: any;
  password: any;
  revokeId: any;
  revokeName: any;
  revokeData: any;
  revokePassword: any;
  revokeInvoitePassword: any;
  isProfileComplete: any;
  onClickDisabled = false;
  userRoles: any;
  userRole: any;
  isEdit: any = false;
  userId: any;
  get displayName(): any {
    return localStorage.getItem('displayName');
  }
  constructor(private  dataService: DataService, private router: Router) {
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      this.router.navigate(['/']);
    }
    if ( (window.localStorage.getItem('userRole') === '2' || window.localStorage.getItem('userRole') === '3') && window.localStorage.getItem('isauthenticated') === 'true') {
      this.router.navigate(['orders']);
    }
  }

  ngOnInit() {
    this.getRolesData();
    this.getRolesList();
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#roles').css('color', '#d77229');
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
  }

  getRolesData(){
    this.revokePassword = '';
    this.revokeInvoitePassword = '';
    this.nao.go(30);
    this.dataService.getRolesData(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.nao.go(100);
        this.rolesData = data;
        this.rolesData = this.rolesData.data;
      },
      (error) => {
        this.nao.go(100);
      }
    );
  }
  getRolesList() {
    this.dataService.getRolesList(window.localStorage.getItem('token')).subscribe(
      data => {
        console.log(data);
        this.userRoles = data['data'];
        for(let i = 0; i < this.userRoles.length; i++) {
          this.userRoles[i].selected = false;
        }
      },
      err => console.log(err)
    );
  }
  selectAll(event) {
    console.log(this.userRoles);
    if(event.target.checked === true) {
      for(let i = 0; i < this.userRoles.length; i++) {
        this.userRoles[i].selected = true;
        this.personRole.push(this.userRoles[i].id);
      }
    }
    if(event.target.checked === false) {
      for(let i = 0; i < this.userRoles.length; i++) {
        this.userRoles[i].selected = false;
        this.personRole = [];
      }
    }
  }
  personRoleId(event, roleId) {
    if(event.target.checked === true) {
      this.personRole.push(roleId);
      $('#selectAll').prop("checked", false);
    } else {
      const index = this.personRole.indexOf(roleId);
      $('#selectAll').prop("checked", false);
      this.personRole.splice(index, 1);
    }
    console.log(this.personRole);
  }
  openAddRolePopup() {
    $('.role-selector').val(1);
    // this.isProfileComplete = localStorage.getItem('meter');
    // console.log('isProfileComplete', this.isProfileComplete);
    // if (this.isProfileComplete < 100) {
    // $('#errorPopIfProfileNotComleted').modal('show');
      // toastr.error('Please complete your profile');
    // return;
    // }
    this.addRoleBtn = true;
    this.personEmail = '';
    this.personName = '';
    // this.personRole = 1;
    this.personEmailError = '';
    for(let i = 0; i < this.userRoles.length; i++) { //initialized with blank unchecked form on opening new role
      this.userRoles[i].selected = false;
    }
    $('#addRolePopup').modal('show');
  }
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  checkRollVal(){
      if(this.personName !== '' && this.personEmail !== '' && this.personRole.length != 0) {
        this.addRoleBtn = false;
      } else {
        this.addRoleBtn = true;
      }
  }
  openAuthenticatePop(editCheck) {
    // console.log('personRole', this.personRole);
    this.isEdit = editCheck;
    this.onClickDisabled = false;
    this.password = '';
    this.personEmailError = '';
    var mail = this.validateEmail(this.personEmail);
    if ( mail === false ) {
      this.personEmailError = 'Please Enter Valied Email Address';
    } else {
      $('#addRolePopup').modal('hide');
      $('#editRolePopup').modal('hide');
      setTimeout(() => {
        $('#authenticatePop').modal('show');
      }, 1000);
    }

  }
  addNewRole() {
    this.onClickDisabled = true;
    this.nao.go(30);
    this.dataService.addNewRoles(window.localStorage.getItem('token'), this.personName, this.personEmail, this.personRole.sort(), this.password).subscribe(
      (data) => {
        this.nao.go(100);
        console.log(data);
        this.roleSucessData = data;
        if ( this.roleSucessData.success === true ) {
          toastr.success('Role Add sucessfuly');
          $('.role-selector').val(1);
          $('#authenticatePop').modal('hide');
          this.getRolesData();
          this.onClickDisabled = false;
        }
        if ( this.roleSucessData.success === false ) {
          toastr.error('Unauthenticate user access');
          $('#authenticatePop').modal('hide');
          this.getRolesData();
          this.onClickDisabled = false;
        }
      },
      (error) => {
        this.nao.go(100);
        this.onClickDisabled = false;
        // console.log('error', error);
      }
    );
  }
  editAdminRoleUser(userId){
    this.nao.go(30);
    this.dataService.getEditAdminUser(window.localStorage.getItem('token'), userId).subscribe(
      data => {
        this.nao.go(100);
        this.personName = data['name'];
        this.personEmail = data['email'];
        this.userRole = data['data'];
        this.personRole = [];
        for(let i = 0; i < this.userRoles.length; i++) {
          this.userRoles[i].selected = false;
          for(let j = 0; j < this.userRole.length; j++) {
            if(this.userRoles[i].id == this.userRole[j].id) {
              this.userRoles[i].selected = true;
              this.personRole.push(this.userRole[j].id);
              this.checkRollVal();
            } 
          }
        }
        this.userId = userId;
        $('#editRolePopup').modal('show');
      },
      err => {
        this.nao.go(100);
        console.log(err)
      }
    );
  }
  editUserRole() {
    console.log('asdf');
    this.nao.go(30);
    this.dataService.updateUserRole(window.localStorage.getItem('token'), this.userId, this.personRole.sort()).subscribe(
      data => {
        this.nao.go(100);
        console.log(data);
        this.roleSucessData = data;
        if ( this.roleSucessData.success === true ) {
          toastr.success('Role updated sucessfuly');
          $('.role-selector').val(1);
          $('#authenticatePop').modal('hide');
          this.getRolesData();
          this.onClickDisabled = false;
        }
        if ( this.roleSucessData.success === false ) {
          toastr.error('Unauthenticate user access');
          $('#authenticatePop').modal('hide');
          this.getRolesData();
          this.onClickDisabled = false;
        }
      },
      err => {
        this.nao.go(100);
        console.log(err);
      }
    );
  }
  conformPopFun(id, name){
    this.revokeId = id;
    this.revokeName = name;
    this.revokePassword = '';
    $('#revockConformPopup').modal('show');
  }
  revokePassPop() {
    this.onClickDisabled = false;
    $('#revockConformPopup').modal('hide');
    setTimeout(() => {
      $('#revockPassword').modal('show');
    }, 1000);
  }
  revokeAcess(){
  //   this.onClickDisabled = true;
  //   this.nao.go(30);
  //   this.dataService.revokeAccess(window.localStorage.getItem('token'), this.revokeId, this.revokePassword).subscribe(
  //     (data) => {
  //       this.nao.go(100);
  //       this.revokeData = data;
  //       $('#revockPassword').modal('hide');
  //       toastr.success(this.revokeData.message);
  //       if ( this.revokeData.success === true  ) {
  //         this.getRolesData();
  //         this.onClickDisabled = false;
  //       } else {
  //         this.onClickDisabled = false;
  //       }
  //     },
  //     (error) => {
  //       this.nao.go(100);
  //       this.onClickDisabled = false;
  //       // console.log('error', error);
  //     }
  //   );
  }
  conformPopFunInvite(id, name){
    this.revokeInvoitePassword = '';
    this.revokeId = id;
    this.revokeName = name;
    $('#revockConformPopupInvitation').modal('show');
  }
  revockInvitePassPop(){
    $('#revockConformPopupInvitation').modal('hide');
    setTimeout(() => {
      $('#revockInvitePassword').modal('show');
    }, 1000);
  }
  revokeInvoiteFinal(){
  //   this.nao.go(30);
  //   this.dataService.revokeInvoite(window.localStorage.getItem('token'), this.revokeId, this.revokeInvoitePassword).subscribe(
  //     (data) => {
  //       this.nao.go(100);
  //       this.revokeData = data;
  //       $('#revockInvitePassword').modal('hide');
  //       toastr.success(this.revokeData.message);
  //       if ( this.revokeData.success === true  ) {
  //         this.getRolesData();
  //       }
  //     },
  //     (error) => {
  //       this.nao.go(100);
  //       // console.log('error', error);
  //     }
  //   );
  }
}



// WEBPACK FOOTER //
// ./src/app/business-roles/business-roles.component.ts